<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  mounted() {
    let htmlwidth =
      document.documentElement.clientWidth || document.body.clientWidth;
    // 获取html的dom
    let htmldom = document.getElementsByTagName("html")[0];
    //设置html的font-size
    htmldom.style.fontSize = (20 / 375) * htmlwidth + "px";
    window.addEventListener("resize", (e) => {
      let htmlwidth = document.documentElement.clientWidth || document.body.clientWidth;
      htmldom.style.fontSize = (20 / 375) * htmlwidth + "px";
    });
  },
  methods: {},
};
</script>

<style>
@import "./assets/css/base.scss";
* {
  margin: 0;
  padding: 0;
  list-style: none;
  -webkit-tap-highlight-color:rgba(0,0,0,0);
}
a {
  color: #666;
  -webkit-user-select: none;
  -moz-user-focus: none;
  -moz-user-select: none;
}
a:link,
a:hover,
a:active {
  color: #666;
  text-decoration: none;
}
img {
  border: 0;
}
ul,
li,
p,
h1,
h2,
h3,
h4,
h5,
h6,
dl,
dt,
dd {
  margin: 0;
  padding: 0;
  list-style: none;
}
.clear:before {
  display: table;
  content: "";
  clear: both;
}
.clear:after {
  display: table;
  content: "";
  clear: both;
}
.left {
  float: left;
}
.right {
  float: right;
}
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(255, 255, 255, 0.8);
  -webkit-box-shadow: inset 0 0 6px rgba(255, 255, 255, 0.8);
  background-color: rgba(255, 255, 255, 1);
  border-radius: 10px;
}
::-webkit-scrollbar {
  width: 8px;
  background-color: transparent;
  height: 8px;
}
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #CFCFCF;
}
#app,
.main {
  width: 100%;
  min-height: 100vh;
}
/* 弹出 */
.el-popup-parent--hidden {
  overflow: auto !important;
}
.el-dialog__header {
  background-color: #c17821 !important;
}
.el-dialog__title,
.el-dialog__headerbtn .el-dialog__close {
  color: #fff !important;
}
.el-dialog__footer {
  padding-bottom: 40px !important;
  padding-left: 0px !important;
  padding-right: 0px !important;
  text-align: center !important;
}
.qd {
  height: 26px;
  line-height: 26px;
  width: 110px !important;
  border-radius: 0px;
  border: none !important;
  background-color: #c17821 !important;
  padding: 0px !important;
  margin: 0 auto !important;
  border-radius: 5px !important;
}
.qd:hover {
  background-color: #c17821 !important;
}
.el-dialog__body {
  padding: 10px 30px!important;
}
.el-form-item__label {
  font-size: 16px!important;
  color: #3a3a3a!important;
  font-family: "SourceHanSansMedium"!important;
  font-weight: 500;
  padding: 0px !important;
}
.el-form-item {
  margin-bottom: 12px!important;
}
:root {
  --swiper-theme-color: #c17821 !important;
}
.work .el-button--primary,.mwork .el-button--primary {
  background: #c17821 !important;
  border: none !important;
}
.work .el-textarea__inner,.mwork .el-textarea__inner{
  min-height:100px !important;
}
.jobe .el-form-item__content,.mjobe .el-form-item__content {
  width: 100% !important;
}
.jobe .el-button,.mjobe .el-button {
  width: 100% !important;
  background: #c17821 !important;
  border: none !important;
}
/* 企业简介 */
.ab{
  width:100%;
  height:auto;
}
.ab p{
  width:100%;
  font-size: 16px;
  font-family: 'SourceHanSansRegular';
  font-weight: 400;
  color: #3A3A3A;
  line-height: 45px;
  text-indent:2em;
  margin-bottom:45px;
}
.aba img{
  display:block;
  width:48%;
  height:auto;
  margin-bottom:45px;
}
.abb{
  width:100%;
  height:auto;
}
.abb li{
  width:32%;
  margin-left:1%;
}
.abb li:first-child{
  margin-left:0;
}
.abb li:nth-child(2){
  margin-left:2%;
}
.abb li img{
  display:block;
  width:100%;
  height:auto;
}
.abb li{
  display:block;
  text-align:center;
  font-size: 14px;
  font-family: 'SourceHanSansLight';
  font-weight: 400;
  color: #3A3A3A;
  margin-top:15px;
}
/* 手机界面 */
@media (max-width: 768px) {
.mab{
  width:100%;
  height:auto;
}
.mab p{
  width:100%;
  font-size: 0.75rem;
  font-family: 'SourceHanSansRegular';
  font-weight: 400;
  color: #3A3A3A;
  line-height:1.25rem;
  text-indent:2em;
  margin:0.6rem 0;
}
.maba img{
  display:block;
  width:100%;
  height:auto;
  margin:0 auto;
  margin-bottom:0.6rem;
}
.mabb{
  width:100%;
  height:auto;
}
.mabb li{
  width:100%;
  margin:0 auto;
}
.mabb li:nth-child(2){
  margin-left:0
}
.mabb li img{
  display:block;
  width:100%;
  height:auto;
}
.mabb li{
  display:block;
  width:100%;
  margin:0 auto;
  text-align:center;
  font-size: 0.6rem;
  line-height:1.5rem;
  font-family: 'SourceHanSansRegular';
  font-weight: 400;
  color: #3A3A3A;
}
}
</style>


// WEBPACK FOOTER //
// src/App.vue